/**
 * Values are interpolated bare into an identity `q` filter (the DSL has no
 * quoting); grammar-significant characters are stripped so free-text input can't
 * malform the query.
 */
export function sanitizeFilterQueryValue(value: string): string {
  return value
    .replace(/[&|()[\]=]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
